<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('sparePartReplacement.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('sparePartReplacement.pageTitle'),
            href: '/admin/spare-part-replacements',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal ts-space-y-3">
          <div class="row">
            <label class="required col-form-label col-md-1">{{
              $t('sparePartReplacement.date')
            }}</label>
            <div class="col-md-4">
              <a-date-picker 
                class="ts-w-full" v-model="model.replacement_date"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                :allowClear="false"
              ></a-date-picker>
            </div>
          </div>
          <div class="row">
            <label class="required col-form-label col-md-1">{{
              $t('sparePartReplacement.textSearch')
            }}</label>
            <div class="col-md-11">
              <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded">
                <SearchBox
                  v-model="fetchOptions"
                  :waiting="fetchIngProduct"
                  @onEnter="fetchProduct"
                />
                <div
                  class="ts-h-32 ts-border ts-border-blue-300 ts-mt-3 ts-rounded ts-overflow-y-scroll ts-p-3"
                >
                  <ts-loading-banner :loading="fetchIngProduct">
                    <table class="ts-w-full">
                      <thead>
                        <tr>
                          <th
                            class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3"
                          >
                            {{ $t('sparePartReplacement.barcode') }}
                          </th>
                          <th
                            class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3"
                          >
                            {{ $t('sparePartReplacement.group') }}
                          </th>
                          <th
                            class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3"
                          >
                            {{ $t('sparePartReplacement.productNameEn') }}
                          </th>
                          <th
                            class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3"
                          >
                            {{ $t('sparePartReplacement.category') }}
                          </th>
                          <th
                            class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3"
                          >
                            {{ $t('sparePartReplacement.grade') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(product, index) in main_products"
                          :key="index"
                        >
                          <td class="ts-py-1 ts-px-3">{{ product.barcode }}</td>
                          <td class="ts-py-1 ts-px-3">
                            {{ product.product_group_name_en }}
                          </td>
                          <td class="ts-py-1 ts-px-3">
                            {{ product.product_name_en }}
                          </td>
                          <td class="ts-py-1 ts-px-3">
                            {{ product.category_name_en }}
                          </td>
                          <td>
                            <select
                              class="form-control"
                              v-model="model.product_grade"
                            >
                              <option value="A">A</option>
                              <option value="B">B</option>
                              <option value="C">C</option>
                              <option value="D">D</option>
                            </select>
                            <div class="validate" v-if="errors.has('product_grade')">
                              {{ errors.first('product_grade') }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ts-loading-banner>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="required col-form-label col-md-1">{{
              $t('sparePartReplacement.itemDetail')
            }}</label>
            <div class="col-md-11">
              <ItemDetail v-model="model" :validate="errors" ref="details" />
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-1 ts-uppercase">{{
              $t('sparePartReplacement.remark')
            }}</label>
            <div class="col-md-4">
              <textarea
                v-model="model.remarks"
                rows="3"
                class="form-control"
              ></textarea>
            </div>
            <div class="col-md-7">
              <div class="ts-flex ts-justify-end ts-items-end ts-space-x-3">
                <ts-button
                  @click.prevent="
                    $router.push({ name: 'spare-part-replacement' })
                  "
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  :waiting="waiting"
                  @click.prevent="onUpdatePreview"
                  color="primary"
                  outline
                  >{{ $t('updatePreview') }}</ts-button
                >
                <ts-button
                  :waiting="waiting_update"
                  @click.prevent="onUpdate"
                  color="primary"
                  >{{ $t('update') }}</ts-button
                >
              </div>
            </div>
          </div>
        </form>

        <a-modal
          :title="$t('pdf')"
          width="50%"
          v-model="show_pdf"
          :zIndex="1020"
          :footer="null"
        >
          <ts-preview-pdf v-model="waiting" :src="src" />
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import ItemDetail from './components/item-detail'
import SearchBox from './components/search-box'
import { mapActions } from 'vuex'
export default {
  name: 'replacementEdit',
  components: {
    ItemDetail,
    SearchBox,
  },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_update: false,
      fetchIngProduct: false,
      show_pdf: false,
      main_products: [],
      src: null,
      model: {
        replacement_date: moment().format('DD-MM-YYYY'),
        product_id: null,
        product_grade: '',
        uom_id: null,
        serial_no: '',
        product_list: [],
        remarks: null,
      },
      fetchOptions: {
        search_value: '',
      },
    }
  },
  computed: {},
  methods: {
    ...mapActions('wholesale/replacement', [
      'getMainProduct',
      'getReplacementProduct',
    ]),
    onUpdate() {
			this.waiting_update = true
			this.$store.dispatch('wholesale/replacement/update', {
				id: this.$route.params.id,
				data: this.model
			})
			.then(response => {
				this.$router.push({ name: 'spare-part-replacement' })
			})
			.catch(error => {
				this.$toasted.error(error.message)
				this.errors = new Errors(error.errors)
			})
			.finally(() => {
				this.waiting_update = false
			})
    },
    onUpdatePreview() {
			this.waiting = true
			this.src = null
			this.show_pdf = true
			this.$store.dispatch('wholesale/replacement/update', {
				id: this.$route.params.id,
				data: this.model
			})
			.then(response => {
				this.src = response.url
				this.clearInput()
			})
			.catch(error => {
				this.$toasted.error(error.message)
				this.errors = new Errors(error.errors)
				this.show_pdf = false
			})
			.finally(() => {
				this.waiting = false
			})
    },
    clearInput() {
      this.model.replacement_date = moment().format('DD-MM-YYYY')
      this.model.product_list = []
      this.model.remarks = null
      this.model.product_id = null
      this.model.uom_id = null
      this.model.serial_no = ''
      this.main_products = []
      this.fetchOptions.search_value = ''
      this.$refs.details.addNew()
    },
    fetchProduct() {
      this.fetchIngProduct = true
      this.getMainProduct(this.fetchOptions)
        .then((response) => {
          this.main_products = response.data
          this.onClickProduct(response.data[0])
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetchIngProduct = false
        })
    },
    async onClickProduct(product) {
      if (product.product_add_on.length == 0) {
        this.$refs.details.loading = true
        await this.getReplacementProduct()
        this.$refs.details.loading = false
      } else {
        let products = product.product_add_on.map((el) => el.sale_code.product)
        this.$store.commit('wholesale/replacement/SET_PRODUCT', products)
      }
      this.model.product_id = product.product_id
      this.model.uom_id = product.uom_category.unit_of_measures.filter(u => u.is_default == true).reduce((i, v) => v.uom_id, null)
      this.model.serial_no = product.serial_no
      this.model.product_grade = product.new_product_grade
			this.model.product_list = []
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/replacement/CLEAR_SETUP', [])
    next()
  },
}
</script>

<style scoped>
table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
}
</style>